import { GIFEncoder, quantize, applyPalette } from 'gifenc';

// 访客二维码GIF参数: 前2秒纯黑 -> 5秒渐显 -> 完整停留2秒后循环
// 场景: 业务员下载后添加到微信表情包
const GIF_SIZE = 240;			// 输出尺寸(微信表情包常用方形尺寸, 文件小)
const BLACK_DELAY = 2000;		// 黑屏时长(ms)
const FADE_FRAMES = 20;			// 渐显帧数
const FADE_FRAME_DELAY = 250;	// 每帧间隔(ms), 20帧 x 250ms = 5秒
const HOLD_DELAY = 2000;		// 完整二维码停留时长(ms)

function loadImage(src) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = () => reject(new Error('二维码图片加载失败'));
		img.src = src;
	});
}

/**
 * 把静态二维码base64合成为"黑屏-渐显"动画GIF
 * @param {string} qrBase64 二维码PNG的dataURL
 * @returns {Promise<Blob>} GIF Blob
 */
async function buildGuestQrGif(qrBase64) {
	const img = await loadImage(qrBase64);
	const canvas = document.createElement('canvas');
	canvas.width = GIF_SIZE;
	canvas.height = GIF_SIZE;
	const ctx = canvas.getContext('2d');
	const gif = GIFEncoder();

	// 渲染一帧: alpha=0为纯黑, alpha=1为完整二维码
	const renderFrame = (alpha) => {
		ctx.globalAlpha = 1;
		ctx.fillStyle = '#000000';
		ctx.fillRect(0, 0, GIF_SIZE, GIF_SIZE);
		if (alpha > 0) {
			ctx.globalAlpha = alpha;
			ctx.drawImage(img, 0, 0, GIF_SIZE, GIF_SIZE);
		}
		return ctx.getImageData(0, 0, GIF_SIZE, GIF_SIZE).data;
	};
	const writeFrame = (rgba, delay) => {
		const palette = quantize(rgba, 256);
		const index = applyPalette(rgba, palette);
		gif.writeFrame(index, GIF_SIZE, GIF_SIZE, { palette, delay });
	};

	// 帧1: 纯黑2秒
	writeFrame(renderFrame(0), BLACK_DELAY);
	// 帧2~21: 5秒渐显(末帧即完整二维码, 停留2秒后循环回黑屏)
	for (let i = 1; i <= FADE_FRAMES; i++) {
		const alpha = i / FADE_FRAMES;
		const delay = i === FADE_FRAMES ? HOLD_DELAY : FADE_FRAME_DELAY;
		writeFrame(renderFrame(alpha), delay);
	}
	gif.finish();
	return new Blob([gif.bytes()], { type: 'image/gif' });
}

export default buildGuestQrGif;
